// Busqueda de casos en toda la conversacion (D45): palabras sueltas, en cualquier orden y sin tildes, en asunto, numero,
// cliente, empresa, etiquetas, mensajes, correos del hilo y notas. La hace correo-api con el texto completo de Postgres;
// aqui solo se piden los ids en orden de relevancia y la Consola los cruza con los filtros de la vista.
import { request } from './http';

export type Busqueda = { ids: string[]; fragmentos: Map<string, string>; aproximado: boolean; total: number };
type Respuesta = { casos: { id: string; numero: number | null; fragmento: string | null }[]; total: number; aproximado: boolean };

// La lista y el conteo de una vista piden la misma busqueda casi a la vez: se comparte por unos segundos.
const recientes = new Map<string, { hasta: number; p: Promise<Busqueda | null> }>();

// `null` si el buscador no esta disponible (se esta preparando o no responde): quien llama usa la busqueda simple.
export function buscarEnCasos(q: string, limite = 2000): Promise<Busqueda | null> {
  const t = q.trim();
  const clave = `${limite}|${t.toLowerCase()}`;
  const c = recientes.get(clave);
  if (c && c.hasta > Date.now()) return c.p;
  const p = request<Respuesta>('/correo/api/casos/buscar', { query: { q: t, limite } })
    .then((r) => ({
      ids: r.casos.map((x) => x.id),
      fragmentos: new Map(r.casos.filter((x) => x.fragmento).map((x) => [x.id, x.fragmento as string])),
      aproximado: r.aproximado,
      total: r.total,
    }))
    .catch(() => null);
  recientes.set(clave, { hasta: Date.now() + 20_000, p });
  if (recientes.size > 50) for (const [k, v] of recientes) if (v.hasta < Date.now()) recientes.delete(k);
  return p;
}

// Ordena por la relevancia que dio el buscador (posicion en `ids`).
export function enOrden<T extends { id: string }>(xs: T[], ids: string[]) {
  const pos = new Map(ids.map((id, i) => [id, i]));
  return [...xs].sort((a, b) => (pos.get(a.id) ?? 1e9) - (pos.get(b.id) ?? 1e9));
}
